import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "change_lang_btn" }

import { computed, onMounted } from 'vue';
import { i18n } from '@/i18n';
import { loadMyPropertyPreferences, myPropertyPreferences, saveMyPropertyPreferences } from '@/appLogic/view/preferences';
import { supportedLang } from '@/coreDomainsModule/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeLanguage',
  setup(__props) {

const t = i18n.t;

onMounted(async () => {
  await loadMyPropertyPreferences();
  const lang = myPropertyPreferences.language;
  if (i18n) i18n.locale = lang ?? 'ja';
});

/**
 * 選択されている言語情報
 */
const selectLang = computed((): string => {
  if (!i18n) return 'en';
  return i18n.locale;
});

/**
 * 選択言語切り替え処理
 */
const changeLang = async () => {
  // なんか型が...
  let targetLang: supportedLang = 'ja';

  // 切り替え先の表示言語ハンドリング
  switch (selectLang.value) {
    case 'ja':
      targetLang = 'en';
      break;
    case 'en':
      targetLang = 'ja';
      break;
    default:
      targetLang = 'ja';
  }
  if (i18n && i18n) i18n.locale = targetLang;
  myPropertyPreferences.language = targetLang;
  await saveMyPropertyPreferences();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", { onClick: changeLang }, _toDisplayString(_unref(t)('Lang') + ': ' + selectLang.value), 1)
  ]))
}
}

})